// [CurveBeam] - [BoneVue]

import dcmjs from 'dcmjs';
import { ByteArray } from 'dicom-parser';

const ImplementationClassUID = '2.25.37069599682585517994988158784759291.1.0.0';
const ImplementationVersionName = 'OHIF-VIEWER-Tree-Metadata-1.0.0';
const EXPLICIT_VR_LITTLE_ENDIAN = '1.2.840.10008.1.2.1';

const { DicomMetaDictionary, DicomDict } = dcmjs.data;
const { denaturalizeDataset } = DicomMetaDictionary;

// [CurveBeamAI]
// eslint-disable-next-line
export function convertNaturalizedReportToPart10Buffer(naturalizedReport: any): ByteArray {
  const meta = {
    FileMetaInformationVersion: naturalizedReport._meta.FileMetaInformationVersion?.Value,
    MediaStorageSOPClassUID: naturalizedReport.SOPClassUID,
    MediaStorageSOPInstanceUID: naturalizedReport.SOPInstanceUID,
    TransferSyntaxUID: EXPLICIT_VR_LITTLE_ENDIAN,
    ImplementationClassUID,
    ImplementationVersionName,
  };

  const denaturalized = denaturalizeDataset(meta);
  const dicomDict = new DicomDict(denaturalized);
  dicomDict.dict = denaturalizeDataset(naturalizedReport);
  const part10Buffer = dicomDict.write();
  return part10Buffer;
}
